import { Regions } from '@wicadu/langscope'

import globalTranslations from '@translations/ui/search-articles/global.json'

export const SEARCH_ARTICLES_TRANSLATIONS = {
  [Regions.Global]: globalTranslations,
} as const
